import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  checkConnection(event) {
    if (!navigator.onLine) {
      event.preventDefault();
      location.reload();
      return false;
    }
    return true;
  }
}
